<template>
  <div class="added-product" v-loading.lock="loading">
    <div ref="headsection" class="head-section">
      <div style="width: 100%;height: 35px">
        <div class="crumbs-navigation" style="width: 40%;float:left">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/main' }">
              {{ $t('productAdded.myQuotation') }}
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              <a @click="toSecond">
                {{ $t('productAdded.productConfigurationGroup') }}
              </a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              {{ $t('productAdded.productAdded') }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div
          class="tab-p"
          style="width: 60%;float: right"
          v-if="$route.params.groupDistinguish !== '3'"
        >
          <div class="tab-b clear">
            <a @click="tabAdd">{{ $t('productAdded.addProduct') }}</a>
            <a @click="added">{{ $t('productAdded.productAdded') }}</a>
            <div class="clearfloat" />
          </div>
        </div>
      </div>

      <div style="display: flex; padding: 12px 0;">
        <span style="color:red ;cursor:pointer">
          <img
            alt="err"
            src="../../icons/laba-gonggao.png"
            style="vertical-align:middle; margin-bottom: 2px; margin-right: 10px; height: 21px; width: 21px"
          >
        </span>
        <span style="color:red ">{{ $t('productAdded.serviceConsultTube') }}</span>
      </div>

      <el-row>
        <el-col :span="19" style="text-align: left">
          <span v-if="!configurationGroup.isService" class="mr-10">
            <label>
              <input
                style="position: relative; top: 1px; left: 4px; cursor: pointer;"
                type="checkbox"
                v-model="checked"
                @click="checkAll"
              >
            </label>
            {{ $t('productAdded.selectAll') }}
            <el-button
              type="primary"
              slot="reference"
              size="mini"
              :disabled="checkedList.length<1 && checkedItemList.length<1"
              style="margin-left: 8px; padding: 6px 15px; color: #3fbbdc;"
              @click="deleteGroupSubs"
            >
              {{ $t('productAdded.delete') }}
            </el-button>
            <el-button
              type="primary"
              slot="reference"
              size="mini"
              :disabled="checkedList.length<1 && checkedItemList.length<1"
              @click="copyItems"
              style="padding: 6px 15px;"
            >
              {{ $t('productAdded.copy') }}
            </el-button>
            <!-- 需要屏蔽的地方 -->
            <el-button
              type="danger"
              icon="el-icon-star-on"
              size="mini"
              v-if="$route.params.groupDistinguish !== '3'"
              class="open-package-style"
              @click="openPackage"
            >
              {{ $t('productAdded.collectionProduction') }}
            </el-button>
            <!-- 批量选服务按钮 -->
            <el-button
              v-if="!configurationGroup.isService"
              type="primary"
              @click="ShowMultipleServiceConfigClick"
            >
              {{ $t('productAdded.batchSelectionService') }}
            </el-button>
          </span>
          <span>{{ $t('productAdded.configurationGroupName') }}:{{ groupNameT }}&nbsp;
            <i
              class="el-icon-edit"
              @click="editName"
              style="cursor:pointer;"
            /></span>
          <span style="display: inline-block; margin-right: 10px;margin-left: 10px;">
            <a>
              {{ $t('productAdded.priceRMB') }}
              （<span style="color: #fd7f57">{{ productPriceFormat(null,null,orderPrice) }}</span>）
            </a>
          </span>
          <span>
            <a>
              {{ $t('productAdded.amount') }}
              （<span class="f-black">{{ orderNumber }}</span>）
            </a>
          </span>
        </el-col>
        <el-col :span="5" style="text-align: right">
          <span
            class="my-collect mr-10"
            @click="openUserCollection"
            v-if="!configurationGroup.isService && $route.params.groupDistinguish !== '3'"
          >
            <span>
              <i class="el-icon-star-on" />{{ $t('productAdded.myFavorite') }}</span>
          </span>
          <el-button
            type="primary"
            @click="saveConfigProduct"
          >
            {{ $t('productAdded.back') }}
          </el-button>
          <el-button type="primary" @click="saveProduct">
            {{ $t('productAdded.save') }}
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table-added" ref="headtable" style="margin-top:20px;">
      <table
        width="100%"
        cellspacing="0"
        cellpadding="0"
      >
        <thead style="height:4rem;margin: 10px;">
          <tr>
            <th style="width:76px">No.</th>
            <th style="width:155px; min-width: 155px">
              {{ $t('productAdded.productName') }}
            </th>
            <th style="width:157px; min-width: 157px">
              {{ $t('productAdded.productModel') }}
            </th>
            <th style="width:227px; min-width: 227px">
              {{ $t('productAdded.productDes') }}
              <button
                @click="expandDiscribe"
                class="product-des"
              >
                {{ $t('productAdded.expandOrCloseAll') }}
              </button>
            </th>
            <th style="width:124px; min-width: 124px">
              {{ $t('productAdded.priceRMB') }}
            </th>
            <th style="width:122px; min-width: 122px">
              {{ $t('productAdded.quantitySet') }}
            </th>
            <th style="width:60px; min-width: 60px">
              {{ $t('productAdded.serviceClassification') }}
            </th>
            <th style="width:115px; min-width: 115px">
              {{ $t('productAdded.status') }}
            </th>
            <!-- 判断常规汇总与服务汇总展示配置服务 -->
            <th
              v-if="!configurationGroup.isService"
              style="width:100px; min-width: 100px;"
            >
              {{ $t('productAdded.serviceConfiguration') }}
            </th>
            <!--<th style="width:59px; min-width: 59px">-->
            <!--  {{ '测试type-&#45;&#45;&#45;&#45;' }}-->
            <!--</th>-->
            <th
              style="width:123px; min-width: 123px; word-break: break-word;"
              v-if="!configurationGroup.isService"
            >
              {{ $t('productAdded.powerConsumption') }}
            </th>
            <th style="width:88px; min-width: 88px">
              {{ $t('productAdded.remarks') }}
            </th>
            <th style="width:85px; min-width: 85px">
              {{ $t('productAdded.parameter') }}
            </th>
            <th style="width:100%; min-width: 250px">
              {{ $t('productAdded.operate') }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td :colspan="subColspan">
              <div ref="divCss" style="overflow-y: auto;padding-bottom: 1px">
                <draggable
                  v-model="groupSubItemDListVOList"
                  :options="{handle:'.paixu', scroll:true, forceFallback:true, animation:150 ,dragClass:'yanse'}"
                >
                  <table
                    style="width: 100%; border-bottom:1px solid #DCDFE6; margin-bottom: 10px;"
                    cellspacing="0"
                    cellpadding="0"
                    v-for="(item,j) in groupSubItemDListVOList"
                    :key="item.categoryId"
                  >
                    <tr>
                      <td style="width:76px; text-align: left; padding-left: 10px;border:none;">
                        <template class="f-blue">{{ item.subItemOrder }}</template>
                      </td>
                      <th
                        class="s-title"
                        :colspan="subColspan"
                        style="border-right: 0;vertical-align:middle;"
                      >
                        <label>
                          <input
                            style="margin-left: 3px;"
                            type="checkbox"
                            v-model="checkedList"
                            :value="item.subId"
                            @click="checkSubAllItem(item,$event)"
                          >
                        </label>
                        <span style="width: 17%;font-weight: 700">
                          <el-input
                            style="width: 80%;margin-top:12px;margin-bottom: 12px;"
                            v-model="item.subProductName"
                            :placeholder="$t('addConfigModule.enterProductName')"
                            @change="saveSubProductName(item)"
                          />
                        </span>
                        <span
                          style="width: 17%;"
                          v-if="!configurationGroup.isService"
                        >
                          <el-tooltip
                            class="item"
                            effect="light"
                            content="Only the sum of the power consumption of equipment other than the power supply in a single set of products is counted"
                            placement="right-end"
                          >
                            <img
                              src="../../assets/questionMark.png"
                              style="height: 12px;width:12px;transform:translateY(6%)"
                              alt="err"
                            >
                          </el-tooltip>
                          {{ $t('productAdded.oncePowerConsumption') }}：
                          <template class="f-blue">
                            {{ productPriceFormat(null,null,item.powerDissipationCount) }}
                          </template>
                        </span>
                        <span style="width: 17%">
                          {{ $t('productAdded.priceRMB') }}：
                          <template style="color: #fd7f57">
                            {{ productPriceFormat(null,null,item.productPriceCount) }}
                          </template>
                        </span>
                        <span
                          v-if="item.productItems[0] && item.productItems[0].calculation !== 1 && item.productItems[0].calculation !== 2"
                        >
                          {{ $t('productAdded.amount') }}：
                          <el-input-number
                            v-model="item.tcount"
                            controls-position="right"
                            :disabled="item.productItems[0] && item.productItems[0].isCalculation===3?true:false"
                            :precision="0"
                            :min="0"
                            @change="handleChangeNumberSum(item);"
                            :label="$t('productAdded.discountFont')"
                            size="mini"
                            style="width: 80px"
                          />
                        </span>
                        <ProductRule :group-sub-item-list-v-o="item" class="check-total-styles" />
                      </th>
                      <th
                        colspan="2"
                        class="operator"
                      >
                        <!-- 需要屏蔽的地方 -->
                        <el-button
                          type="text"
                          @click="productDetails(item)"
                          v-if="showAddProductFlg(item.productItems)==='zhuji' &&$route.params.groupDistinguish !== '3'"
                        >
                          {{ $t('productAdded.eploymentConfiguration') }}
                        </el-button>
                        <el-button
                          type="text"
                          v-if="!configurationGroup.isService &&$route.params.groupDistinguish !== '3'"
                          @click="copyGroupSubItem(item.projectId,item.subId)"
                        >
                          {{ $t('productAdded.copy') }}
                        </el-button>
                        <el-button
                          type="text"
                          @click="deleteGroupSubItem(item.subId)"
                          v-if="$route.params.groupDistinguish !== '3' && item.canEdit === true && item.productItems[0] && item.productItems[0].isCalculation != 3 "
                        >
                          {{ $t('productAdded.delete') }}
                        </el-button>
                        <el-button
                          type="text"
                          @click="groupPaiXu(item)"
                        >
                          {{ $t('productAdded.clickRemove') }}
                        </el-button>
                      </th>
                    </tr>
                    <tr>
                      <td style="border:none" />
                      <td :colspan="itemColspan">
                        <draggable
                          v-model="item.productItems"
                          :options="{handle:'.paixu',scroll:true,forceFallback:true,animation: 150,dragClass:'yanse'}"
                        >
                          <table
                            style="width: 100%;"
                            cellspacing="0"
                            cellpadding="0"
                            v-for="(por,index) in item.productItems"
                            :key="por.itemId"
                          >
                            <tr>
                              <td
                                style="width:155px; min-width: 155px"
                                class="product-alias;"
                              >
                                <label>
                                  <input
                                    style="margin-left: 3px"
                                    type="checkbox"
                                    v-model="checkedItemList"
                                    :value="por.itemId"
                                    @change="clickSubItem(item,$event)"
                                  >
                                </label>
                                <el-input
                                  style="width: 80%;font-size:100%"
                                  v-model="por.productAlias"
                                  :placeholder="$t('addConfigModule.enterProductName')"
                                  @change="saveUserProductAlias(por)"
                                />
                              </td>
                              <td style=" width:157px; min-width: 157px; text-align: left;padding: 5px 0 3px 5px;">
                                <div class="img-wrap">
                                  <span>{{ por.productName }}</span>
                                  <img height="20" v-if="!por.industryIsEnabled" src="../../assets/shelves-new.png" alt="err">
                                  <img height="20" v-if="por.quotation===1" src="@/assets/fuwushang-new.png" alt="err">
                                  <img height="20" v-if="por.quotation===2 && getStore('industryFlg') === 1" src="@/assets/fuwushang-new.png" alt="err">
                                </div>
                              </td>
                              <td
                                style="white-space: normal;text-align: justify;padding:0 10px; width:227px; min-width: 227px"
                              >
                                <long-text
                                  :text="por.productDesc"
                                  :switch-flg="switchFlgP"
                                />
                              </td>
                              <td style="width:125px; min-width: 125px; text-align: right">
                                {{ productPriceFormat(null,null,por.productPrice) }}
                              </td>
                              <!--数量/套数,需要修改的逻辑部分-->
                              <!-- null true 只有false的时候不可以编辑-->
                              <td style="width:122px; min-width: 122px; text-align: left; padding-left: 10px;">
                                <el-input-number
                                  size="mini"
                                  ref="refNumber"
                                  controls-position="right"
                                  :disabled="por.isCalculation===3?true:false"
                                  v-model="por.purchaseQuantity"
                                  :precision="0"
                                  @change="handleChange(item,j,por);"
                                  :min="0"
                                  :max="por.optionalType === 1 &&
                                    por.subPropertyName === '主机' ? 1 : 99999&&configurationGroup.isService && por.maxNum ? por.maxNum:99999"
                                  class="hostname"
                                />
                              </td>
                              <td style="width:60px; min-width: 60px; text-align: left; padding-left: 10px">
                                {{ por.productPscType }}
                              </td>

                              <td style="width:115px; min-width: 115px; text-align: left; padding-left: 10px">
                                <ProductStatusFomation :scope="por" />
                              </td>
                              <td v-if="!configurationGroup.isService"
                                  style="width:100px; min-width: 100px;color: #3fbbdc"
                              >
                                <div
                                  @click="clickServeConfig(por,j, index)"
                                  v-if="por.serviceSelectedName !='' && por.serviceSelectedName != null"
                                  style="width:100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                                  :title="por.serviceSelectedName"
                                >
                                  {{ por.serviceSelectedName }}
                                </div>
                              </td>
                              <!--<td style="width:59px; min-width: 59px;text-align: left; padding-left: 10px">-->
                              <!--  {{ por.productType }}-->
                              <!--</td>-->
                              <td
                                style="width:123px; min-width: 123px; text-align: left; padding-left: 10px"
                                v-if="!configurationGroup.isService"
                              >
                                {{ ((por.powerAdd!=0.00 && por.powerDissipation==0.00)?"":(por.powerDissipation)) }}
                              </td>
                              <td style="width:88px; min-width: 88px; text-align: left;">
                                <!--备注-->
                                <el-button
                                  type="text"
                                  style="color: #3fbbdc"
                                  circle
                                  @click="viewRemarks(por.itemId)"
                                >
                                  {{ $t('homePage.compile') }}
                                </el-button>
                              </td>
                              <td style="width: 85px;min-width: 85px; text-align: left;">
                                <el-button
                                  type="text"
                                  circle
                                  @click="viewParamsRemarks(por.itemId)"
                                >
                                  {{ $t('homePage.compile') }}
                                </el-button>
                              </td>
                              <td
                                style="width: 100%;"
                                class="operator"
                              >
                                <el-button
                                  type="text"
                                  @click="deleteProductItem(por.itemId)"
                                  v-if="por.canEdit === true && item.productItems[0] && item.productItems[0].isCalculation != 3"
                                >
                                  {{ $t('productAdded.delete') }}
                                </el-button>
                                <el-button
                                  type="text"
                                  @click="toReplace(item,por)"
                                  v-if="(item.propertyCode==='1001' || item.propertyCode==='1007')&&((por.propertyCode!=='1001'&&por.propertyCode!=='1007')||(item.subProductCode===por.productCode&&por.optionalType!==1))&& $route.params.groupDistinguish !== '3'"
                                >
                                  {{ $t('productAdded.replace') }}
                                </el-button>
                                <el-button class="paixu">
                                  {{ $t('productAdded.remove') }}
                                  <img src="../../assets/updown.png" alt="err">
                                </el-button>
                              </td>
                            </tr>
                          </table>
                        </draggable>
                      </td>
                    </tr>
                  </table>
                </draggable>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--编辑配置组弹出框-->
    <span class="edit-name">
      <el-dialog
        :title="$t('productAdded.editConfigurationGroup')"
        :visible.sync="dialogFormVisible"
        width="450px"
      >
        <el-form
          :model="configurationGroup"
          :rules="rules"
          :inline="true"
          ref="configurationGroup"
          @submit.native.prevent
          @keyup.enter.native="editGroupName"
        >
          <el-form-item
            :label="$t('productAdded.configurationGroupName')"
            prop="groupName"
          >
            <el-input
              v-model.trim="configurationGroup.groupName"
              :placeholder="$t('productAdded.pleaseEnterTheContent')"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">
            {{ $t('homePage.takeAway') }}
          </el-button>
          <el-button type="primary" @click="editGroupName()">
            {{ $t('homePage.confirm') }}
          </el-button>
        </div>
      </el-dialog>
    </span>
    <!--排序-->
    <el-dialog
      :title="$t('productAdded.configureDragBox')"
      :visible.sync="productPaiXu"
      :close-on-click-modal="false"
      :show-close="false"
      width="450px"
    >
      <div
        class="table-added"
        ref="headtable"
        style="margin-bottom: 10px"
      >
        <table width="100%" cellspacing="0" cellpadding="0">
          <thead>
            <tr style="height: 3rem;">
              <th style="text-align:center; width:5%">NO.</th>
              <th style="text-align:center; width:30%">
                {{ $t('productAdded.teamName') }}
              </th>
              <th style="text-align:center; width: 18%">
                {{ $t('productAdded.priceRMB') }}
              </th>
              <th style="text-align:center; width: 15%">
                {{ $t('productAdded.amount') }}
              </th>
              <th style="text-align:center; width: 10%">
                {{ $t('productAdded.numberOf') }}
              </th>
              <th style="text-align:center;width: 23%">
                {{ $t('productAdded.operate') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td :colspan="subColspan">
                <!--style="overflow-y: auto;padding-bottom: 1px"-->
                <div ref="divCss">
                  <draggable v-model="subList" :options="{handle:'.paixu',scroll:true,forceFallback:true,animation: 150 ,dragClass:'yanse'}">
                    <table
                      class="f-table"
                      width="100%"
                      cellspacing="0"
                      cellpadding="0"
                      v-for="(item) in subList"
                      :key="item.subId"
                    >
                      <tr>
                        <td style="text-align:center; width:3%">
                          {{ item.subItemOrder }}
                        </td>
                        <td style="text-align:center;width:17%">
                          {{ item.subProductName }}
                        </td>
                        <td style="text-align:center;width:10%">
                          {{ productPriceFormat(null,null,item.productPriceCount) }}
                        </td>
                        <td style="text-align:center;width:9%">
                          {{ item.productCount }}
                        </td>
                        <td style="text-align:center;width:6%">
                          {{ item.tcount }}
                        </td>
                        <td style="text-align:center;width:13%">
                          <span class="paixu">
                            {{ $t('productAdded.remove') }}
                            <img src="../../assets/updown.png" alt="err"></span>
                        </td>
                      </tr>
                    </table>
                  </draggable>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelByPaiXu"> {{ $t('homePage.takeAway') }}</el-button>
        <el-button type="primary" @click="saveConfigProductSort"> {{ $t('homePage.confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--填写备注信息-->
    <el-dialog
      :title="$t('productAdded.noteInformation')"
      :visible.sync="productRemarksVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="450px"
    >
      <el-form
        :model="productRemarks"
        :rules="remarkRules"
        ref="productRemarks"
      >
        <div class="grid-content ">
          <el-form-item class="grid-content" prop="productRemark">
            <el-input
              type="textarea"
              maxlength="200"
              :autosize="{ minRows: 4, maxRows: 6}"
              :placeholder="$t('productAdded.pleaseEnterNoteInformation')"
              v-model="productRemarks.productRemark" @input="descInput"
            />
            <span class="numberV">{{ txtVal }}/200</span>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeRemarks">{{ $t('homePage.takeAway') }}</el-button>
        <el-button type="primary" @click="saveProductRemark()">{{ $t('homePage.confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--填写参数信息-->
    <el-dialog
      :title="$t('productAdded.parameterMessage')"
      :visible.sync="paramsRemarksVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="450px"
    >
      <el-form
        :model="paramsRemarks"
        :rules="remarkRules"
        ref="paramsRemarks"
      >
        <div class="grid-content ">
          <el-form-item class="grid-content" prop="productRemark">
            <el-input
              type="textarea"
              maxlength="200"
              :autosize="{ minRows: 4, maxRows: 6}"
              :placeholder="$t('productAdded.inputParameterMessage')"
              v-model="paramsRemarks.paramsRemark" @input="descInput2"
            />
            <span class="numberV">{{ txtVal2 }}/200</span>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeParamesRemarks"> {{ $t('homePage.takeAway') }}</el-button>
        <el-button type="primary" @click="saveParamsRemark()">{{ $t('homePage.confirm') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('productAdded.addProductTogether')"
      width="450px"
      :visible.sync="packageDialogFormVisible"
      @submit.native.prevent
      @keyup.enter.native="savePackage"
    >
      <el-form
        :rules="packageNameRules"
        ref="configurationGroup"
      >
        <el-form-item
          :label="$t('productAdded.togetherName')"
          label-width="140px"
          prop="packageName"
        >
          <el-input
            v-model.trim="packageName"
            :placeholder="$t('productAdded.pleaseEnterTheContent')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="packageDialogFormVisible = false;packageName = ''"
        >
          {{ $t('homePage.takeAway') }}
        </el-button>
        <el-button type="primary" @click="savePackage">{{ $t('homePage.confirm') }}</el-button>
      </div>
    </el-dialog>
    <UserCollection
      ref="myCollection"
      :configuration-group="configurationGroup"
    />
    <ProductRuleList
      ref="mychildProductRuleList"
      :group-sub-item-list-v-o-s="groupSubItemDListVOList"
      :project-id="configurationGroup.projectId"
    />
    <el-drawer
      ref="addProductDialogue"
      title=""
      size="100%"
      :modal="false"
      :visible.sync="drawer"
      :with-header="false"
      destroy-on-close
      direction="btt"
      @open="open"
    >
      <Config
        ref="config"
        :current-row="currentRow"
        :configuration-group="configurationGroup"
      />
    </el-drawer>


    <!--配置服务  弹出框==========================-->
    <el-dialog
      v-if="serviceConfigDialogVisible"
      :visible.sync="serviceConfigDialogVisible"
      :show-close="true"
      width="650px"
      :close-on-click-modal="false"
    >
      <span>
        <service-config :product="currentRow" />
      </span>
    </el-dialog>


    <!-- 多个配置服务 -->
    <el-dialog
      v-if="isShowMultipleServiceConfig"
      :visible.sync="isShowMultipleServiceConfig"
      center
      :show-close="true"
      width="650px"
      :close-on-click-modal="false"
    >
      <span>
        <Multiple-ServiceConfig :product="firstRow" />
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Api from '../../api';
import step from '../../utils/step';
import longText from '../quotationlist/longText';
import eventBus from '@/utils/eventBus';
import { productPriceFormat } from '@/utils/numberFormater';
import draggable from 'vuedraggable';
import { SpecialCharacterCheck } from '@/utils/form-validator';
import UserCollection from '../additionproduct/UserCollection';
import ProductRule from '../components/ProductRule';
import ProductRuleList from '../components/ProductRuleList';
import { isPartnerM, getStore, notesTextFormat } from '@/utils/mUtils';
import ProductStatusFomation from '../components/ProductStatusFomation';
import ProductTypeFormation from '../components/ProductTypeFormation';
import Config from './Config';
import ServiceConfig from '../serviceconfig/ServiceConfig';  // 导入 服务配置组件
// 导入 多个配置服务
import MultipleServiceConfig from '../MultipleServiceConfig/MultipleServiceConfig';

export default {
  name: 'AdditionProduct',
  mixins: [step],
  // eslint-disable-next-line vue/no-unused-components
  components: {ServiceConfig, MultipleServiceConfig, longText, Config, draggable, UserCollection, ProductRule, ProductRuleList, ProductStatusFomation, ProductTypeFormation },
  data () {
    return {
      resizeTimer: null,
      serviceConfigDialogVisible:false, // 单个批量配置服务
      isShowMultipleServiceConfig: false, // 多个批量配置服务
      replaceArr: [],
      drawer: false,
      formLabelWidth: '120px',
      dialogFormVisible: false,
      // 表单验证
      rules: {
        groupName: [{ required: true, message: `${this.$t('addConfigModule.rulesMessage')}`, trigger: 'blur' }, { max: 40, message: `${this.$t('addConfigModule.rulesNumberMessage')}` }]
      },
      packageNameRules: {
        packageName: [{ required: true, message: `${this.$t('addConfigModule.packageRulesName')}`, trigger: 'blur' },
          { max: 40, message: `${this.$t('addConfigModule.rulesNumberMessage')}` }, {
            validator: SpecialCharacterCheck,
            message: `${this.$t('addConfigModule.specialCharacters')}`,
            trigger: 'blur'
          }]
      },
      configurationGroup: {
        projectId: '',
        groupId: '',
        groupName: '',
        isService: false
      },
      projectId: '',
      groupSubItemDListVOList: [],
      checkList: ['选中且禁用', '复选框 A'],
      num1: 0,
      groupNameT: '',
      switchFlgP: true,
      totalRiilPrice: 0,
      productRemarksVisible: false,
      paramsRemarksVisible: false,
      productPaiXu: false,
      productRemarks: {
        itemId: '',
        productRemark: '',
        productCode: ''
      },
      paramsRemarks: {
        itemId: '',
        paramsRemark: '',
        productCode: ''
      },
      txtVal: 0,
      txtVal2: 0,
      checkedList: [],
      checkedItemList: [],
      checked: false,
      loading: false,
      saveFlag: true,
      buttonFlg: true,
      styleObject: {
        height: '',
        'overflow-y': 'auto',
        'margin-bottom': '15px'
      },
      packageList: [],
      packageName: '',
      packageDialogFormVisible: false,
      isPartner: true,
      isOriginal: false,
      subColspan: 17,
      itemColspan: 20,
      currentRow: {},
      firstRow:{},
      subList: [],
      popoverObj: {},
      isInputNumberDisable:false,
      numberValue:0,
      selectedSubIndex: undefined,
      selectedItemIndex: undefined
    };
  },
  computed: {
    // 计算整个配置组的价格
    orderPrice () {
      let cont = 0;
      this.groupSubItemDListVOList.forEach((item) => {
        item.productItems.forEach((items) => {
          cont += (items.purchaseQuantity * items.productPrice) * item.tcount;
        });
      });
      return cont;
    },
    // 数量总计
    orderNumber () {
      let cont = 0;
      this.groupSubItemDListVOList.forEach((item) => {
        item.productItems.forEach((items) => {
          cont += items.purchaseQuantity * item.tcount;
        });
      });
      return cont;
    },
    remarkRules () {
      return {
        productRemark: [
          { required: false, validator: SpecialCharacterCheck, message: '填写内容请勿带有特殊字符', trigger: 'blur' }
        ],
        paramsRemark: [
          { required: false, validator: SpecialCharacterCheck, message: '填写内容请勿带有特殊字符', trigger: 'blur' }
        ]
      };
    }
  },
  methods: {
    // 点击批量选服务按钮事件
    ShowMultipleServiceConfigClick(){
      let different = 0;
      this.packageList.forEach(item => {
        if(this.packageList[0].productItems[0].servicePackageId!== item.productItems[0].servicePackageId){
          different++;
        };
        });
        if(this.packageList.length){
          if(different == 0){
            this.isShowMultipleServiceConfig = true;
           this.firstRow = this.packageList[0].productItems[0];
          }else{
            this.$message.error(`${this.$t('productAdded.selectVolumeService')}`);
          }
        }
    },
    handlePopover (item, productCode) {
      this.replaceProductModelAxios(productCode, item);
    },
    async replaceProductModelAxios (productCode, item) {
      try {
        const result = await Api.replaceProductModel(productCode, item);
        if (result.data.status === '200') {
          this.popoverObj = result.data.data[0];
          this.popoverObj.newShelfTime = this.popoverObj.newShelfTime.substr(0, 10);
        } else {
          this.$notify.error(result.data.err);
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleReplace (por, item, popoverObj) {
      this.handleReplaceAxios(por, item, popoverObj);
    },
    async handleReplaceAxios (por, item, popoverObj) {
      try {
        this.$confirm(`${this.$t('productAdded.message_003')}`, `${this.$t('productAdded.prompt')}`, {
          confirmButtonText: this.$t('homePage.confirm'),
          cancelButtonText: this.$t('homePage.takeAway'),
          type: 'warning'
        }).then(() => {
          this.loading = true;
          let body = {
            subId: por.subId,
            propertyCode: por.propertyCode,
            sameTypeProductCode: por.productCode,
            subPropertyCode: por.subPropertyCode,
            subProductCode: item.subProductCode,
            productSeriesId: item.productSeriesId,
            productCode: por.productCode,
            userCollection: '',
            keyWords: '',
            projectId: por.projectId,
            itemId: por.itemId,
            newProductCode: popoverObj.newProductCode
          };
          Api.handleReplaceApi(body).then(res => {
            let json = res.data;
            if (json.status === '200') {
              this.$notify.success(this.$t('productAdded.replaceSucceeded'));
              this.loadData();
            }
          }).catch(e => {
            this.$notify.error(this.$t('productAdded.networkAnomaly'));
          });
          this.loading = true;
        });
      } catch (e) {
        console.log(e);
      }
    },
    productPriceFormat,
    getStore,
    isPartnerM,
    notesTextFormat,
    openUserCollection () {
      this.saveProduct();
      this.$refs.myCollection.openUserCollection();
      this.$refs.myCollection.openPackageCollection();
    },
    showAddProductFlg (productItems) {
      // 主机或者主体软件
      let zhuji = productItems.filter(p => p && (p.propertyCode === '1001' || p.propertyCode === '1007' || p.showPrecise === 1));
      if (zhuji.length > 0) {
        return 'zhuji';
      }
    },
    calculateSeriesAttribute (item, j) {
      // 系列总功耗
      let gongHao = 0;
      // 系列总价格
      let xiLieZongJia = 0;
      // 系列总数
      let xilieZongShu = 0;
      for (let i = 0; i < item.productItems.length; i++) {
        let productItem = item.productItems[i];
        gongHao += (productItem.powerDissipation) * productItem.purchaseQuantity;
        xilieZongShu += item.tcount * productItem.purchaseQuantity;
        xiLieZongJia += productItem.productPrice * productItem.purchaseQuantity * item.tcount;
        // if (productItem.calculation === 1) {
        //   // xilieZongShu +=1;
        //   xiLieZongJia += productItem.productPrice;
        // } else {
        //
        // }
      }
      item.powerDissipationCount = gongHao;
      item.productPriceCount = xiLieZongJia;
      item.productCount = xilieZongShu;
    },
    // 跳转至配置组
    toSecond () {
      if (this.$route.params.groupDistinguish !== '3') {
        this.$refs.mychildProductRuleList.getProductRuleList();
      } else {
        this.$router.go(-1);
      }
    },
    // tab 切换 添加产品
    tabAdd () {
      let params = this.$route.params;
      this.$router.push({
        name: 'AdditionProduct/add',
        params: { ...params, routerPath: 'AddedProduct' }
      });
    },
    // tab 切换 已添加产品
    added () {
      this.$router.push({
        name: 'AddedProduct/added',
        params: {
          groupId: this.configurationGroup.groupId,
          groupName: this.groupNameT,
          projectId: this.configurationGroup.projectId,
          projectName: this.configurationGroup.projectName,
          isService: this.configurationGroup.isService
        }
      });
    },
    //修改数量总额改变产品列表价格，和整单价格和数量总计
    handleChangeNumberSum(item,j){
      this.calculateSeriesAttribute(item, j);
    },
    // 需要修改的,数量展示逻辑判断方法
    handleChange (item, j, por) {
      // minNum存在,并且选中值大于默认 0, 并且小于 minNum 直接把minNum赋值给当前选中值
    if(por.minNum !== null && this.numberValue <por.minNum){
      por.purchaseQuantity=por.minNum;
    }
      this.calculateSeriesAttribute(item, j);
      this.$nextTick(()=>{
        this.numberValue =this.$refs.refNumber[0].currentValue;
          if (this.configurationGroup.isService && por && !por.isRiil && (por.calculation === 2 || por.calculation === 1)) {
          this.saveProduct();
        } else {
          this.calculateSeriesAttribute(item, j);
        }
        });
    },
    // 保存并返回
    saveConfigProduct () {
      this.buttonFlg = false;
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      Api.saveConfigProduct(body)
        .then(result => {
          if (result.data.status === '200') {
            // this.loadData();
             this.$notify.success(`${this.$t('productAdded.saveSucceeded')}`);
            this.toSecond();
          } else {
            this.$notify.error(result.data.err);
          }
        })
        .catch(() => {
          this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
        });
    },
    getGroupType () {
      let groupType = 1;
      if (this.configurationGroup.isService) {
        groupType = 2;
      }
      return groupType;
    },
    // 只保存操作
    saveProduct () {
      if (this.saveFlag) {
        this.saveFlag = false;
        this.productPaiXu = false;
        let groupType = this.getGroupType();
        let body = {
          groupId: this.configurationGroup.groupId,
          groupSubItemDListVOList: this.groupSubItemDListVOList,
          groupType: groupType
        };
        this.loading = true;
        Api.saveConfigProduct(body)
          .then(result => {
            if (result.data.status === '200') {
              this.saveFlag = true;
              this.loadData();
               this.$notify.success(`${this.$t('productAdded.saveSucceeded')}`);
            } else {
              this.loading = false;
              this.loadData();
              this.$notify.error(result.data.err);
            }
          })
          .catch(() => {
            this.saveFlag = true;
            this.loading = false;
            this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
          });
      }
    },
    // 保存排序
    saveConfigProductSort () {
      debugger;
      if (this.saveFlag) {
        this.saveFlag = false;
        this.productPaiXu = false;
        let groupType = this.getGroupType();
        let body = {
          groupId: this.configurationGroup.groupId,
          groupSubItemDListVOList: this.subList,
          groupType: groupType
        };
        this.loading = true;
        Api.saveConfigProductSort(body)
          .then(result => {
            if (result.data.status === '200') {
              this.saveFlag = true;
              this.loadData();
               this.$notify.success(`${this.$t('productAdded.saveSucceeded')}`);
            } else {
              this.loading = false;
              this.loadData();
              this.$notify.error(result.data.err);
            }
          })
          .catch(()=> {
            this.saveFlag = true;
            this.loading = false;
            this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
          });
      }
    },

    cancelByPaiXu () {
      this.subList = [];
      this.productPaiXu = false;
    },

    deleteGroupSubItem (subId) {
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      this.loading = true;
      this.loading = false;
      this.$confirm(`${this.$t('productAdded.message_001')}`, `${this.$t('productAdded.prompt')}`, {
        confirmButtonText:  this.$t('homePage.confirm'),
        cancelButtonText:  this.$t('homePage.takeAway'),
        type: 'warning'
      }).then(() => {
        this.loading = true;
        let param = {
          params: {
            groupId: this.configurationGroup.groupId,
            subId: subId
          }
        };
        Api.saveConfigProduct(body)
          .then(result => {
            if (result.data.status === '200') {
              Api.deleteGroupSubItem(param)
                .then(result => {
                  if (result.data.status === '200') {
                    this.loadData();
                  } else {
                    this.$notify.error(result.data.err);
                  }
                  this.loading = false;
                })
                .catch(e => {
                  this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
                  this.loading = false;
                  console.error('error', e);
                });
            } else {
              this.$notify.error(result.data.msg);
            }
          }).catch(e => {
            this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('productAdded.hasBeenDelete')
        });
      });
    },

    copyGroupSubItem (projectId, subId) {
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      this.loading = true;
      this.loading = false;
      this.$confirm(`${this.$t('productAdded.message_004')}`, `${this.$t('productAdded.prompt')}`, {
        confirmButtonText: this.$t('homePage.confirm'),
        cancelButtonText: this.$t('homePage.takeAway'),
        type: 'warning'
      }).then(() => {
        let param = {
          params: {
            projectId: projectId,
            subId: subId
          }
        };
        this.loading = true;
        Api.saveConfigProduct(body).then(res => {
          let json = res.data;
          if (json.status === '200') {
            Api.copySub(param)
              .then(result => {
                if (result.data.status === '200') {
                  this.loadData();
                } else {
                  this.$notify.error(result.data.err);
                }
              })
              .catch(() => {
                this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
              });
          } else {
            this.$notify.error(`${this.$t('productAdded.saveFail')}`);
          }
        });
      }).catch(() => {
        this.loading = false;
      });
    },
    copyItems () {
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      let query = this.$route.query;
      this.$confirm(`${this.$t('productAdded.message_005')}`, `${this.$t('productAdded.prompt')}`, {
        confirmButtonText: this.$t('homePage.confirm'),
        cancelButtonText:  this.$t('homePage.takeAway'),
        type: 'warning'
      }).then(() => {
        this.loading = true;
        Api.saveConfigProduct(body).then(res => {
          let json = res.data;
          if (json.status === '200') {
            Api.copyItems({
              projectId: this.configurationGroup.projectId,
              subIds: this.checkedList,
              itemIds: this.checkedItemList
            }).then(result => {
              if (result.data.status === '200') {
                this.loadData();
                this.clearChecked();
                this.loading = false;
              } else {
                this.loading = false;
                this.$notify.error(result.data.err);
              }
            })
              .catch(e => {
                this.loading = false;
                this.$notify.error(`${this.$t('productAdded.copyFail')}`);
                console.error('error', e);
              });
          } else {
            this.$notify.error(`${this.$t('productAdded.saveFail')}`);
          }
        });
      }).catch(() => {
        this.loading = false;
      });
    },
    deleteProductItem (itemId) {
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      this.loading = true;
      this.loading = false;
      this.$confirm(`${this.$t('productAdded.message_001')}`, `${this.$t('productAdded.prompt')}`, {
        confirmButtonText: this.$t('homePage.confirm'),
        cancelButtonText: this.$t('homePage.takeAway'),
        type: 'warning'
      }).then(() => {
        this.loading = true;
        let param = {
          params: {
            itemId: itemId
          }
        };
        Api.saveConfigProduct(body)
          .then(result => {
            if (result.data.status === '200') {
              Api.deleteProductItem(param)
                .then(result => {
                  if (result.data.status === '200') {
                    this.loadData();
                    this.loading = false;
                  } else {
                    this.$notify.error(result.data.err);
                    this.loading = false;
                  }
                })
                .catch(() => {
                  this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
                  this.loading = false;
                });
            } else {
              this.$notify.error(result.data.msg);
            }
          })
          .catch(e => {
            this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('productAdded.hasBeenDelete')
        });
      });
    },
    editName () {
      this.configurationGroup.groupName = this.groupNameT;
      this.dialogFormVisible = true;
    },
    editGroupName () {
      if (this.configurationGroup.groupName === this.groupNameT) {
        this.dialogFormVisible = false;
        return false;
      }
        this.$refs['configurationGroup'].validate((valid) => {
          if (valid) {
            let param = {
              groupId: this.configurationGroup.groupId,
              groupName: this.configurationGroup.groupName,
              projectId: this.configurationGroup.projectId
            };
            Api.updateGroupNameByGroupId(param).then(result => {
              if (result.data.status === '200') {
                this.$message.success(`${this.$t('productAdded.updateSuccess')}`);
                this.groupNameT = this.configurationGroup.groupName;
                this.dialogFormVisible = false;
              } else {
                this.$message.error(result.data.data);
              }
            })
              .catch(error => {
                console.log(error);
                this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
              });
          } else {
            return false;
          }
        });


    },
    loadData () {
      let param = {
        params: {
          groupId: this.configurationGroup.groupId,
          groupName: this.configurationGroup.groupName,
          projectId: this.configurationGroup.projectId
        }
      };
      this.loading = true;
      Api.getGroupProductList(param)
        .then(result => {
          if (result.status === 200 && result.data.status === '200') {
            this.configurationGroup.groupName = result.data.data.group.groupName;
            this.groupNameT = this.configurationGroup.groupName;
            this.groupSubItemDListVOList = result.data.data.list;
            // console.log('groupSubItemDListVOList',this.groupSubItemDListVOList);
            this.groupSubItemDListVOList.forEach(item => {
              this.calculateSeriesAttribute(item, null);
            });
            this.loading = false;
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('AddedProduct.vue error', error);
        });
    },
    // 点击显示当前产品详情列表
    productDetails (row) {
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      this.loading = true;
      let query = this.$route.query;
      Api.saveConfigProduct(body).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.currentRow = row;
          this.drawer = true;
        } else {
          this.$notify.error(this.$t('productAdded.saveFailed'));
        }
      });
      this.loading = false;
    },
    // 抽屉显示触发
    open () {
      this.$nextTick(function () {
        // 调用接口获取初始化数据
        this.$refs.config.getData(this.currentRow);
        // 给弹出框中的组件赋值高度，使其可以超出滚动
        this.$refs.config.height = this.$refs.addProductDialogue.$refs.drawer.offsetHeight;
      });
    },
    // 选择配置跳转
    selectAccessories (subId, groupId) {
      this.buttonFlg = false;
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      Api.saveConfigProduct(body)
        .then(result => {
          if (result.data.status === 200) {
            this.$router.push({
              name: '/SelectAccessories/add',
              params: {
                subId: subId,
                groupId: groupId,
                projectId: this.configurationGroup.projectId,
                groupName: this.groupNameT,
                isService: this.configurationGroup.isService
              }
            });
          } else {
            this.$notify.error(result.data.err);
          }
        })
        .catch(e => {
          this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
        });
    },
    // 添加产品
    selectProduct (subId, groupId, seriesId) {
      this.buttonFlg = false;
      // console.log("this.configurationGroup.isService",this.configurationGroup.isService);
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      // console.log('body: ',body)
      Api.saveConfigProduct(body)
        .then(result => {
          if (result.data.status === '200') {
            this.$router.push({
              name: '/SelectProduct/add',
              params: {
                subId: subId,
                groupId: groupId,
                projectId: this.configurationGroup.projectId,
                seriesId: seriesId,
                groupName: this.groupNameT,
                isService: this.configurationGroup.isService
              }
            });
          } else {
            this.$notify.error(result.data.err);
          }
        })
        .catch(e => {
          this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
        });
    },
    productDesc (val) {
      let cont = '';
      cont = val.length > 22 ? val.substring(0, 22) : val;
      return cont;
    },
    changText (val) {
      if (val.ifShow === undefined) {
        this.$set(val, 'ifShow', true);
      } else {
        val.ifShow = !val.ifShow;
      }
    },
    expandDiscribe () {
      // longText.expandDisc();
      this.switchFlgP = !this.switchFlgP;
      eventBus.$emit('longTextDisc');
    },
    getRiilPrice () {
      if (this.totalRiilPrice === 0) {
        Api.getRiilProductTotalPriceByProjectId(this.configurationGroup.projectId).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.totalRiilPrice = json.data;
          }
        });
      }
    },
    viewRemarks (itemId) {
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      this.loading = true;
      Api.saveConfigProduct(body);
      this.loading = false;
      this.productRemarks.itemId = itemId;
      Api.getProductRemark({ params: { 'itemId': itemId } })
        .then(result => {
          if (result.status === 200) {
            this.productRemarks.productRemark = result.data.data.productRemark;
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.productRemarksVisible = true;
    },
    viewParamsRemarks (itemId) {
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      this.loading = true;
      let query = this.$route.query;
      Api.saveConfigProduct(body);
      this.loading = false;
      this.paramsRemarks.itemId = itemId;
      Api.getParamesRemark({ params: { 'itemId': itemId } })
        .then(result => {
          if (result.status === 200) {
            this.paramsRemarks.paramsRemark = result.data.data.paramsRemark;
            this.paramsRemarks.productCode = result.data.data.productCode;
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.paramsRemarksVisible = true;
    },
    groupPaiXu (item) {
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      this.loading = true;
      let query = this.$route.query;
      Api.saveConfigProduct(body).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.loadData();
          this.subList = this.groupSubItemDListVOList;
          this.loading = false;
          this.productPaiXu = true;
        } else {
          this.$notify.error(`${this.$t('productAdded.saveFailed')}`);
        }
      });
    },
    saveProductRemark () {
      this.$refs['productRemarks'].validate((valid) => {
        if (valid) {
          Api.saveProductRemark({
            itemId: this.productRemarks.itemId,
            productRemark: this.productRemarks.productRemark
          })
            .then(result => {
              if (result.data.status === "200") {
                this.$notify.success(this.$t('productAdded.updateSuccess'));
                this.closeRemarks();
              } else {
                this.$message.error(result.data.data);
              }
            })
            .catch(error => {
              console.log(error);
             this.$notify.error(this.$t('productAdded.updateFail'));
            });
        } else {
          return false;
        }
      });
    },
    saveParamsRemark () {
      this.$refs['paramsRemarks'].validate((valid) => {
        if (valid) {
          Api.saveParamsRemark({
            itemId: this.paramsRemarks.itemId,
            paramsRemark: this.paramsRemarks.paramsRemark,
            productCode: this.paramsRemarks.productCode
          })
            .then(result => {
              if (result.data.status === '200') {
                this.$notify.success(`${this.$t('productAdded.updateSuccess')}`);
                this.closeParamesRemarks();
              } else {
                this.$message.error(result.data.data);
              }
            })
            .catch(() => {
              this.$notify.error(`${this.$t('productAdded.updateFail')}`);
            });
        } else {
          return false;
        }
      });
    },
    closeRemarks () {
      this.productRemarks.productRemark = '';
      this.productRemarks.itemId = '';
      this.productRemarksVisible = false;
    },
    closeParamesRemarks () {
      this.paramsRemarks.paramsRemark = '';
      this.paramsRemarks.itemId = '';
      this.paramsRemarksVisible = false;
    },
    descInput () {
      this.txtVal = this.productRemarks.productRemark.length;
    },
    descInput2 () {
      this.txtVal2 = this.paramsRemarks.paramsRemark.length;
    },
    toReplace (item, pro) {
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      this.loading = true;

      let query = this.$route.query;

      Api.saveConfigProduct(body).then(res => {
        let json = res.data;
        if (json.status === '200') {
          let params = {
            subId: item.subId,
            groupId: item.groupId,
            projectId: item.projectId,
            groupName: this.groupNameT,
            isService: this.configurationGroup.isService,
            itemId: pro.itemId,
            productCode: pro.productCode,
            productName: pro.productName,
            subPropertyCode: pro.subPropertyCode,
            subProductCode: item.subProductCode,
            optionalType: pro.optionalType,
            productSeriesId: item.productSeriesId,
            propertyCode: pro.propertyCode
          };
          this.$router.push({
            name: 'ReplaceAddedProduct',
            params: params,
            query: {
              routerPath: query.routerPath
            }
          });
        } else {
          this.$notify.error(json.data.err);
        }
      })
        .catch(() => {
          this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
        });
      this.loading = false;
    },

    checkAll () {
      let _this = this;
      if (_this.checked) { // 实现反选
        _this.checkedList = [];
        _this.checkedItemList = [];
        _this.packageList = [];
      } else { // 实现全选
        _this.checkedList = [];
        _this.checkedItemList = [];
        _this.packageList = [];
        _this.groupSubItemDListVOList.forEach(function (item, index) {
          _this.checkedList.push(item.subId);
          _this.packageList.push(item);
          item.productItems.forEach(prod => {
            _this.checkedItemList.push(prod.itemId);
          });
        });
      }
    },
    checkSubAllItem (sub, $event) {
      let checked = $event.target.checked;
      let that = this;
      if (checked) {
        // 全选
        sub.productItems.forEach(item => {
          if (that.checkedItemList.indexOf(item.itemId) < 0) {
            that.checkedItemList.push(item.itemId);
          }
        });
        that.packageList.push(sub);
      } else {
        // 反选
        sub.productItems.forEach(item => {
          that.checkedItemList.splice(that.checkedItemList.indexOf(item.itemId), 1);
        });
        that.packageList.splice(that.packageList.indexOf(sub.subId), 1);
      }
    },
    clickSubItem (sub, $event) {
      let checked = $event.target.checked;
      let that = this;
      let len = 0;// 一个型号选中产品数量
      if (checked) {
        sub.productItems.forEach(item => {
          if (that.checkedItemList.indexOf(item.itemId) >= 0) {
            len++;
          }
        });
        // that.checkedList是一个型号全选的集合
        if (sub.productItems.length === len) {
          that.checkedList.push(sub.subId);
        }
        // 组合包增加产品
        that.packageList.push(sub);
      } else {
        // 判断全选型号的集合有没有反选的subId，没有则不更改全选型号集合
        if(that.checkedList.includes(sub.productItems[0].subId)){
            that.checkedList.splice(that.checkedList.indexOf(sub.subId), 1);
          };
        // 删除组合包增加产品
        let pLen = 0;
        sub.productItems.forEach(item => {
          if (that.checkedItemList.indexOf(item.itemId) >= 0) {
            pLen++;
          }
        });
        if (pLen === 0) {
          that.packageList.splice(that.packageList.indexOf(sub.subId), 1);
        };
      };
    },
    deleteGroupSubs () {
      this.$confirm(`${this.$t('productAdded.message_001')}`, `${this.$t('productAdded.prompt')}`, {
        confirmButtonText: this.$t('homePage.confirm'),
        cancelButtonText: this.$t('homePage.takeAway'),
        type: 'warning'
      }).then(() => {
        this.loading = true;
        Api.deleteGroupSub({
          projectId: this.configurationGroup.projectId,
          subIds: this.checkedList,
          itemIds: this.checkedItemList
        }).then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.loadData();
            this.clearChecked();
            this.loading = false;
            this.$notify.success(`${this.$t('productAdded.deleteSucceeded')}`);
          }else {
            this.$notify.error(json.err);
          }
        }).catch(e => {
          this.clearChecked();
          this.loading = false;
        });
      }).catch(() => {
        this.clearChecked();
        this.$message({
          type: 'info',
          message: this.$t('productAdded.hasBeenDelete')
        });
      });
    },
    clearChecked () {
      this.checkedList = [];
      this.checkedItemList = [];
      this.packageList = [];
      this.checked = false;
    },
    popoverClose () {
      this.$refs['deleteGroupSubDialog'].doClose();
    },
    saveUserProductAlias (item) {
      let body = {
        productCode: item.productCode,
        subId: item.subId,
        alias: item.productAlias,
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType()
      };
      this.loading = true;
      let query = this.$route.query;
      Api.saveConfigProduct(body);
      this.loading = false;
      Api.saveUserProductAlias(body).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.$message({
            showClose: true,
            duration: 800,
            message: this.$t('productAdded.nameUpdateSucceeded'),
            type: 'success'
          });
        }
      }).catch(() => {
       this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
      });
    },
    saveSubProductName (item) {
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList,
        groupType: this.getGroupType(),
        subId: item.subId,
        subProductName: item.subProductName
      };
      this.loading = true;
      let query = this.$route.query;
      Api.saveConfigProduct(body);
      this.loading = false;
      Api.saveSubProductName(body).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.$message({
            showClose: true,
            duration: 800,
            message: this.$t('productAdded.nameUpdateSucceeded'),
            type: 'success'
          });
        }
      }).catch(e => {
        this.$notify.error(`${this.$t('productAdded.networkAnomaly')}`);
      });
    },
    scollHeight () {
      this.$nextTick(() => {
        const screenH = document.documentElement.clientHeight;
        const headS = this.$refs.headsection ? this.$refs.headsection.offsetHeight : 0;
        const contentHeight = Math.max(screenH - headS - 150, 300);
        if (this.$refs.divCss) {
          this.$refs.divCss.style.height = contentHeight + 'px';
        }
      });
    },
    handleWindowResize () {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.scollHeight();
      }, 150);
    },
    openPackage () {
      let temList = this.packageList;
      if (temList.length > 0) {
        for (let i = 0; i < temList.length; i++) {
          this.packageName = temList[i].subProductName;
          if (i < temList.length - 1) {
            if (temList[i].subId !== temList[i + 1].subId) {
              this.$notify.error(`${this.$t('productAdded.message_008')}`);
              return false;
            }
          }
        }
      } else {
        this.$notify.error(`${this.$t('productAdded.pleaseCheckFavorite')}`);
        return false;
      }
      this.packageDialogFormVisible = true;
    },
    savePackage () {
      Api.savePackage({
        itemIds: this.checkedItemList,
        packageName: this.packageName
      }).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.$notify.success(`${this.$t('productAdded.addProductSucceeded')}`);
          this.packageDialogFormVisible = false;
          this.packageName = '';
          this.clearChecked();
        }
      }).catch(e => {
        this.clearChecked();
        this.loading = false;
        console.error(e);
      });
    },
    validateProductRule (item) {
      return item.calculation !== 2;
    },
    validateSubRule (item) {
      if (item && item.productItems && item.productItems[0]) {
        if (item.productItems[0].calculation !== 2) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    clickOriginal ($event) {
      let checked = $event.target.checked;
      let isOriginal = false;
      let text = this.$t('productAdded.message_006');
      if (checked) {
        isOriginal = true;
        text =this.$t('productAdded.message_007');
      }
      this.$confirm(text, this.$t('productAdded.prompt'), {
        confirmButtonText: this.$t('homePage.confirm'),
        cancelButtonText: this.$t('homePage.takeAway'),
        type: 'warning'
      }).then(() => {
        this.loading = true;
        Api.original({ params: { 'projectId': this.configurationGroup.projectId, 'isOriginal': isOriginal } })
          .then(result => {
            if (result.status === 200) {
              this.loadData();
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }).catch(() => {
        $event.target.checked = false;
        this.$message({
          type: 'info',
          message: 'cancel'
        });
      });
    },
    getOriginalStatus () {
      Api.getOriginalStatus({ params: { 'projectId': this.configurationGroup.projectId } }).then(result => {
        let { status, data } = result;
        if (status === 200) {
          this.isOriginal = data.data;
        }
      })
        .catch(() => {
          this.loading = false;
        });
    },
    toProductQualificationList (productName) {
      let routeData = this.$router.resolve({
        name: 'ProductQualificationList',
        query: { productName: productName }
      });
      window.open(routeData.href, '_blank');
    },
    // 海外配置器
    clickServeConfig(por, j, index) {
          this.serviceConfigDialogVisible = true;
          this.currentRow = por;
          this.selectedSubIndex = j;
          this.selectedItemIndex = index;
        },
    //  事件总线；  单个保存配置服务
    saveServiceConfig(val) {
        if (this.groupSubItemDListVOList[this.selectedSubIndex]) {
          // 更新product_item_serve关系表，调用保存方法计算配置组价格
          let body = {
            itemId: this.groupSubItemDListVOList[this.selectedSubIndex].productItems[this.selectedItemIndex].itemId,
            projectId: this.groupSubItemDListVOList[this.selectedSubIndex].productItems[this.selectedItemIndex].projectId,
            packageId: this.groupSubItemDListVOList[this.selectedSubIndex].productItems[this.selectedItemIndex].servicePackageId,
            groupId: this.configurationGroup.groupId,
            productCode: this.groupSubItemDListVOList[this.selectedSubIndex].productItems[this.selectedItemIndex].productCode,
            serviceList: val
          };
          Api.saveServiceList(body).then(res => {
            let json = res.data;
            if (json.status == 200) {
              this.serviceConfigDialogVisible = false;
              // 校验通过，保存成功，动态设置服务配置的名称
              let mark = 0;
              this.echoServiceConfigName(val,mark);
              this.$notify.success(this.$t('productAdded.saveSucceeded'));
            } else {
              this.$notify.error(json.err);
            }
          }).catch(e => {
            console.error(e);
          });
        }
      },
       //  事件总线；  多个保存配置服务
       batchSaveServiceList(val){
        // console.log('val ==== 批量修改配置服务',val);
        // console.log('选中的产==================品', this.packageList);
        let body = {
            productInformationList:[],
            serviceList: val
          };
          // 判断选中的数组是否有值
        if (this.packageList.length) {
          for (let i = 0; i < this.packageList.length; i++) {
            body.productInformationList.push({
              itemId:this.packageList[i].productItems[0].itemId,
              projectId:this.packageList[i].productItems[0].projectId, // 1079087351516372992
              packageId:this.packageList[i].productItems[0].servicePackageId,
              productCode:this.packageList[i].productItems[0].productCode,
              groupId:this.configurationGroup.groupId,
            });
          }
          Api.batchSaveServiceList(body).then(res => {
            let json = res.data;
            if (json.status == 200) {
              this.isShowMultipleServiceConfig = false;
              // 校验通过，保存成功，动态设置服务配置的名称
              let mark = 1;
              this.echoServiceConfigName(val,mark);
              this.$notify.success(this.$t('productAdded.saveSucceeded'));
              // 修改完毕 批量配置服务 成功之后
              let _this = this;
              _this.checked = false;
              _this.checkedList = [];
              _this.checkedItemList = [];
              _this.packageList = [];
            } else {
              this.$notify.error(json.err);
            }
          }).catch(e => {
            console.error(e);
          });
        }
       },
       // 设置服务配置名称和产品行上的服务产品列表数据
       echoServiceConfigName(val,mark) {
        let serviceName = '';
        for (let i = 0; i < val.length; i++) {
          let valElement = val[i];
          serviceName += valElement.productName;
          serviceName += '（';
          serviceName += valElement.selectedYear;
          serviceName += valElement.productUnit+'）';
          if (i !== val.length - 1) {
            serviceName += '；';
          }
        }
        // console.log('mark',mark);
        if(mark == 0) {
          this.$set(this.groupSubItemDListVOList[this.selectedSubIndex].productItems[this.selectedItemIndex], 'serviceSelectedName', serviceName);
        this.$set(this.groupSubItemDListVOList[this.selectedSubIndex].productItems[this.selectedItemIndex], 'serviceSelectedList', val);
        }
        if (mark == 1) {
          for (let i = 0; i < this.packageList.length; i++) {
          this.$set(this.packageList[i].productItems[0],'serviceSelectedName',serviceName);
          this.$set(this.packageList[i].productItems[0],'serviceSelectedList',val);
        }
        }
      },
  },
  mounted () {
    this.projectName = this.$route.query.projectName;
    this.isPartner = isPartnerM();
    this.scollHeight();
    window.addEventListener('resize', this.handleWindowResize);
    this.groupNameT = this.$route.params.groupName;
    this.configurationGroup.groupId = this.$route.params.groupId;
    this.configurationGroup.groupName = this.$route.params.groupName;
    this.configurationGroup.projectId = this.$route.params.projectId;
    // console.log("this.$route.params.isService=",this.$route.params.isService);
    if (this.$route.params.isService === 'true') {
      this.configurationGroup.isService = true;
    } else if (this.$route.params.isService === 'false') {
      this.configurationGroup.isService = false;
    } else {
      this.configurationGroup.isService = this.$route.params.isService;
    }
    if (this.configurationGroup.isService) {
      this.subColspan = 14;
      this.itemColspan = 17;
    }

    this.loadData();
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.getOriginalStatus();
    eventBus.$on('loadData', () => {
      this.loadData();
    });

     // 传值  控制 单选服务配置的 显示 和隐藏  boolean
     eventBus.$on('serviceConfigShow',(val)=>{
        this.serviceConfigDialogVisible = val;
      });
      // 传值  单个配置服务 已选的服务配置  为 []
      eventBus.$on('saveServiceConfig',(val)=>{
        this.saveServiceConfig(val);
      });

        // 传值  批量配置服务 已选的服务配置  为 []
        eventBus.$on('batchSaveServiceList',(val)=>{
        // 将子组件传递来的值进行传入
        this.batchSaveServiceList(val);
      });
        // 传值  控制 单选服务配置的 显示 和隐藏  boolean
     eventBus.$on('isShowMultipleServiceConfig',(val)=>{

        this.isShowMultipleServiceConfig = val;
      });
    },


  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize);
    clearTimeout(this.resizeTimer);
    eventBus.$off('loadData');
    // 单个修改
    eventBus.$off('serviceConfigShow');
    eventBus.$off('saveServiceConfig');
    // 批量修改
    eventBus.$off('isShowMultipleServiceConfig');
    eventBus.$off('batchSaveServiceList');
  },
  filters: {
    number (value) {
      let toFixedNum = Number(value).toFixed(3);
      let realVal = toFixedNum.substring(0, toFixedNum.toString().length - 1);
      return realVal;
    }
  },
  watch: { // 深度 watcher
    'checkedList': {
      handler: function (val, oldVal) {
        this.checked = val.length === this.groupSubItemDListVOList.length;
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.mr-10{
  margin-right: 10px;
}
</style>

<style lang="scss">
  @import "../../styles/product-common.css";
  .productCodeStyle{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .added-product {
    .open-package-style{
      padding: 6px 15px;
      height: 32px;
      color: #fd7f57;
      background-color: #FFFFFF;
      border-color: #fd7f57;
      .el-icon-star-on{
        font-size: 14px;
      }
    }
    .numberV {
      position: absolute;
      right: 6px;
      bottom: -6px;
      font-size: 12px;
    }
  }
  .productCodeStyle:hover{
    color: dodgerblue;
    cursor: pointer;
  }
  product .head-section {
    height: 80px;
    padding-bottom: 2px;
  }
  .added-product .tab-p .tab-b a:nth-of-type(2) {
    background: #36BADE;
    //border-radius: 5px;
    color: #FFFFFF;
  }
  .added-product .tab-p .tab-b a:nth-of-type(1) {
    border: 1px solid #34A3C9;
    color: #333333;
    //border-right: none;

    background: #FFFFFF;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .added-product .tab-p .tab-b a:nth-of-type(1):hover {
    background: rgba(54, 186, 222, 0.2);
  }
  .clearfloat {
    clear: both;
  }
  .added-product .select-option {
    margin-top: 10px;
  }
  .added-product .table {
    margin-top: 40px;
  }
  .added-product .blue-btn {
    background: #36BADE;
    width: 120px;
    height: 32px;
    color: #FFFFFF;
    border-radius: 5px;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 0;
  }

  .added-product .remarks {
    cursor: pointer;
    background-color: rgba(64, 158, 255, .1);
    padding: 4px 8px;
    border-radius: 4px;
    border: transparent;
  }

  .added-product .remarks:hover {
    border: 1px solid #36BADE;
  }

  .added-product .remarks img {
    width: 24px;
  }

  .added-product {
    .table-added {
      //overflow-y: auto;
      overflow-x: auto;
      //height: 500px;
      //width: 100%;
      table th, td {
        padding: 0;
      }
    }
  }


  .added-product .table-added table thead tr:first-of-type th {
    background-color: #eef1f6;
    color: #333333;
    text-align: left;
    padding-left: 10px;
  }
  .added-product .table-added .product-des{
    float: right;
    color:#3fbbdc;
    border:none;
    border-radius:5px;
    //height:20px;
    margin-right: 7px;
    padding: 0 5px;
  }

  .added-product .table-added table tr:first-of-type th {
    //border-right: 1px solid #FFFFFF;
    border:1px solid #EBEEF5;
  }

  .table-added table .f-table tr {
    background-color: #FFFFFF !important;
    color: #333333;

  }

  .added-product {
    .table-added{
      table{
        border-bottom: 1px solid #dedede;
        .f-table tr th {
          line-height: 2rem;
        }
        td {
          border-bottom: none;
        }

      }
    }
  }

  //.added-product .table-added table{
  //  border-bottom: 1px solid #dedede;
  //}
  //.added-product .table-added table .f-table tr th {
  //  line-height: 2rem;
  //}

  .added-product .table-added table:last-child {
    border-bottom:none;/* 表格横线 */
  }

  .added-product .table-added table .f-table tr th:first-of-type {
    background: #F8F8F8;
    line-height: 3rem !important;
    //padding-bottom: 10px;
  }

  .added-product .table-added table .f-table tr th {
    font-weight: normal;
    border: 1px solid #EBEBEB;
  }

  .added-product .table-added table .f-table tr:last-of-type {
    border-left: none;
  }

  .added-product table .s-table td {
    border: 1px solid #EBEBEB;
  }

  .added-product table .s-table td {
    border-right: none;
  }

  .added-product table .s-table td:last-of-type {
    border-right: 1px solid #EBEBEB;
  }

  .added-product table .s-table tr:first-of-type td {
    border-top: none;
  }

  .added-product table {
    table-layout: fixed;
    height: 62px;
  }

  td {
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    -moz-text-overflow: ellipsis;
  }

  .added-product .select-option {
    text-align: left;
  }

  .added-product .el-dialog .el-input__inner {
    //width: 260px;
    text-align: left;
  }

  .added-product .edit-name .el-input__inner {
    width: 240px;
  }

  .added-product .el-dialog {
    text-align: left;
  }

  .clear {
    clear: both;
  }

  .added-product .select-option .grid-content {
    float: left;
    margin-left: 20px;
  }

  .added-product .select-option .grid-content:last-of-type {
    float: right;
  }

  .added-product .select-option .grid-content:first-of-type {
    margin-left: 0;
  }

  .added-product .table-added tbody tr th {
    text-align: left;
  }

  .added-product .table-added tbody .s-title {
    padding-left: 7px;
  }

  .added-product .table-added tbody .s-title span {
    display: inline-block;
  }

  .added-product .table-added tbody .s-title span div {
    display: inline-block;
  }

  .added-product .table-added tbody .s-title span + span {
    margin-left: 20px;

  }

  .added-product .table-added .operator {
    width:16%;
    text-align: left;
    color: #36BADE;
    border-right: 0px;
    padding-right:5px;
    padding-left:10px;
  }

  .added-product .el-dialog__header {
    text-align: left;
  }

  .added-product .dialog-footer {
    text-align: right;
  }

  .added-product .select-option .grid-content:first-of-type .el-button--default {
    margin-left: 20px;
  }

  .added-product .select-option {
    height: 3.2rem;
    line-height: 3.2rem;
  }

  .added-product .product-alias input {
    border: none;
  }

  .added-product .el-button--primary:hover {
    color: #fff;
    background-color: #60c8e8 !important;
    border-color: #60c8e8 !important;
  }


  .added-product .to-note {
    background: #ECF5FF;
    height: 26px;
    width: 26px;
    display: inline-block;
    border-radius: 5px;
  }

  .added-product .to-note:hover {
    background: #ECF5FF;
    height: 30px;
    width: 30px;
    display: inline-block;
    border-radius: 5px;
    border: 1px solid #36BADE;
  }

  .added-product .to-note img {
    width: 24px;
    vertical-align: middle;
  }

  .paixu {
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    padding: 2px 18px 2px 10px;
    color: #333333;
    margin-left: 4px;
    position: relative;
    cursor: pointer;
  }

  .yanse tr{
    background-color: #36BADE !important;
    color: #ff8487;
  }

  .yanse2 td{
    background-color: #36BADE !important;
    color: #ff8487;
  }

  .paixu img {
    width: 18px;
    height: 16px;
    margin-left: 4px;
    position: absolute;
    right: 1px;
    top: 50%;
    margin-top: -8px;
  }

  .added-product .fixed {
    position: fixed;
    width: 100%;
    background: #ffffff;
    z-index: 1000;
    top: 0;
    padding: 20px 48px 20px 0;
  }

  .added-product .promotion {
    width: 32px;
    height: 20px;
    display: inline-block;
  }

  .added-product .promotion img {
    width: auto;
    height: auto;
    vertical-align: middle;
  }

  .added-product .promotion:hover img {
    width: 35px;
  }

  .added-product .promotion2 {
    width: 40px;
    height: 20px;
    display: inline-block;
  }

  .added-product .promotion2 img {
    width: 40px;
    vertical-align: middle;
  }

  .added-product .promotion2:hover img {
    width: 45px;
  }

  .check-total-styles {
    margin-left: 20px;
  }

  .f-table tr:hover {
    background-color: #c6cfdf !important;
  }

</style>
<style lang="less" scoped>
.added-product .el-button--primary {
  background-color: #FFFFFF !important;
  height: 32px;
  color: #3fbbdc;
  /*background-color: red !important;*/
  border-color: #3fbbdc !important;
}
.hostname{
  width: 80px;
  /deep/ .el-input__inner{
    padding-right: 28px;
  }
}
.img-wrap {
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  align-items: center;
}
</style>
